import { Select } from "@mantine/core";
import { useField } from ".";

type Props = {
  name: string;
  label?: string;
  placeholder: string;
  disabled?: boolean;
  onChange?: (value: string | null) => void;
  noError?: boolean;
  options: { value: string; label: string }[];
  clearable?: boolean;
  classNames?: Partial<Record<string, string>> | undefined;
  searchable?: boolean;
  onSearchChange?: any;
  icon?: any;
  itemComponent?: any;
  multiple?: boolean;
  required?: boolean;
};

export function SelectField({
  name,
  label,
  placeholder,
  noError = false,
  onChange: onChangeValue,
  options = [],
  disabled = false,
  classNames,
  clearable = true,
  searchable,
  onSearchChange,
  icon,
  itemComponent,
  multiple = false,
  required = false,
}: Props) {
  const { value, error, onChange } = useField(name);
  return (
    <Select
      multiple={multiple}
      leftSection={icon}
      label={label}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      searchable={searchable}
      onChange={(value) => {
        onChange(value);
        onChangeValue && onChangeValue(value);
      }}
      error={error}
      required={required}
      clearable={clearable}
      data={options}
      style={{ flex: 1 }}
      classNames={classNames}
      onSearchChange={(query) => {
        const selectedItem = options.find((item) => item.value === value);
        if (onSearchChange) {
          onSearchChange(selectedItem && query === selectedItem.label ? "" : query);
        }
      }}
      styles={{
        error: {
          display: noError ? "none" : "block",
        },
        wrapper: {
          marginBottom: noError && error && 0,
        },
      }}
    />
  );
}
